import { css, theme } from '../lib';

const { screens } = theme;

type MediaQueries = typeof mediaQueries;
type Screens = keyof typeof screens;

const getMinWidth =
  (minSize: Screens) =>
  (...args: any) =>
    css`
      @media (min-width: ${screens[minSize]}) {
        ${css(args.shift(), ...args)}
      }
    `;

const getMaxWidth =
  (maxSize: Screens) =>
  (...args: any) =>
    css`
      @media (max-width: ${screens[maxSize]}) {
        ${css(args.shift(), ...args)}
      }
    `;

const getBetweenWidth = (minSize: Screens) => ({
  and:
    (maxSize: Screens) =>
    (...args: any) =>
      css`
        @media (min-width: ${screens[minSize]}) and (max-width: ${screens[maxSize]}) {
          ${css(args.shift(), ...args)}
        }
      `,
});

const mediaQueries = {
  between: getBetweenWidth,
  max: getMaxWidth,
  min: getMinWidth,
};

export const media: MediaQueries = { ...mediaQueries };
